import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authApi } from "../services/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const token = localStorage.getItem("admin_token");
		if (!token) {
			setLoading(false);
			return;
		}
		authApi
			.me()
			.then(setUser)
			.catch(() => localStorage.removeItem("admin_token"))
			.finally(() => setLoading(false));
	}, []);

	const login = useCallback(async (username, password) => {
		const { token, user: u } = await authApi.login(username, password);
		localStorage.setItem("admin_token", token);
		setUser(u);
	}, []);

	const logout = useCallback(() => {
		localStorage.removeItem("admin_token");
		setUser(null);
	}, []);

	return (
		<AdminAuthContext.Provider value={{ user, loading, login, logout }}>
			{children}
		</AdminAuthContext.Provider>
	);
}

export function useAdminAuth() {
	const ctx = useContext(AdminAuthContext);
	if (!ctx) throw new Error("useAdminAuth must be inside AdminAuthProvider");
	return ctx;
}
